import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  background-color: #0000001c;
  top: 0;
  position: absolute;
  right: 300px;
  bottom: 0;
  left: 0;
  display: none;

  &.show {
    display: block;
  }
`;
